import styled from "styled-components";
import { GridSpg } from "@duosoftbg/nacid-components";

const CategoryWrapperGrid = styled(GridSpg)`
  @media (max-width: 960px) {
    .categoryTile:nth-of-type(n + 2) .serviceContainer:nth-of-type(2) {
      margin-left: 40px;
      width: calc(100% - 40px);
    }
  }

  @media (min-width: 960px) {
    .categoryTile:nth-of-type(4n + 2) .serviceContainer:nth-of-type(2) {
      margin-left: 40px;
      width: calc(400% - 40px);
    }

    .categoryTile:nth-of-type(4n + 3) .serviceContainer:nth-of-type(2) {
      margin-left: calc(-100% + 40px);
      width: calc(400% - 40px);
    }

    .categoryTile:nth-of-type(4n + 4) .serviceContainer:nth-of-type(2) {
      margin-left: calc(-200% + 40px);
      width: calc(400% - 40px);
    }

    .categoryTile:nth-of-type(4n + 5) .serviceContainer:nth-of-type(2) {
      margin-left: calc(-300% + 40px);
      width: calc(400% - 40px);
    }
  }
`;

const CategoryWrapper = ({ children }) => {
  return (
    <CategoryWrapperGrid container spacing={10}>
      {children}
    </CategoryWrapperGrid>
  );
};

export default CategoryWrapper;
